module.exports = __webpack_public_path__ + "static/media/number-three.a4608164.svg";